<div class="flex justify-center items-center h-full">
  <img id="ftc-icon-svg" class="mx-auto" [src]="iconPath" alt="icone" [style.height]="height" [style.margin]="margin" />
</div>
